const LISTAR_DADOS = (state, payload) => {
    state.items = payload
}

// const LISTAR_ORDENACAO = (state, payload) => {
//   state.ordenacao = payload
// }

const CARREGANDO = (state, payload) => {
  state.carregando = payload
}

const INSERIR_MENU_SELECIONADO = (state,  payload) => {
  state.selecionado = payload
}

export {
    LISTAR_DADOS,
    CARREGANDO,
    INSERIR_MENU_SELECIONADO,
    // LISTAR_ORDENACAO
}